import type { INameTag, NameTagStyle } from '../IRenderer';

/**
 * createNameTag — substrate-agnostic factory for name-tag labels
 * (NPCs, mobs, players).
 *
 * Phase H10 Arc λ.10 (2026-05-10): PhaserNameTag fallback removed.
 * PixiFactoriesRegistry wires the Pixi impl at boot.
 */

type PixiFactory = (x: number, y: number, initialText: string, style?: NameTagStyle) => INameTag;

let pixiFactory: PixiFactory | null = null;

export function registerPixiNameTagFactory(fn: PixiFactory): void {
  pixiFactory = fn;
}

export function createNameTag(
  _scene: unknown,
  x: number,
  y: number,
  initialText: string,
  style?: NameTagStyle,
): INameTag {
  if (!pixiFactory) {
    throw new Error('[createNameTag] Pixi factory not registered. Call registerAllPixiFactories() at boot.');
  }
  return pixiFactory(x, y, initialText, style);
}
